import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { mockData } from '../mock';

const TrustedClientsSection = () => {
  const { trustedClients } = mockData;

  return (
    <section className="py-20 bg-white" data-testid="trusted-clients-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center mb-4">
            <CheckCircle2 className="h-8 w-8 text-blue-900 mr-2" />
            <span className="text-blue-900 font-semibold text-lg">Trusted By Leading Companies</span>
          </div>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Valued Clients</h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Proud to serve Kuwait's most respected organizations with premium uniform solutions
          </p>
        </div>

        {/* Clients Logo Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-5">
          {trustedClients.map((client) => (
            <div
              key={client.id}
              data-testid={`client-logo-${client.id}`}
              className="group bg-white rounded-xl p-6 border-2 border-gray-100 hover:border-blue-900 hover:shadow-lg transition-all duration-300 flex items-center justify-center min-h-[140px]"
            >
              <img
                src={client.logo}
                alt={client.name}
                className="max-h-[90px] max-w-[160px] object-contain grayscale group-hover:grayscale-0 transition-all duration-300"
              />
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-12 text-center">
          <p className="text-gray-600 text-lg">
            Join <span className="font-bold text-blue-900">250+ satisfied clients</span> across Kuwait
          </p>
        </div>
      </div>
    </section>
  );
};

export default TrustedClientsSection;
